module.exports = __webpack_public_path__ + "static/media/landRover.8de3101e.png";